import React from 'react'
import styles from '../index.module.scss'

/**
 * B2B verification modal
 * TODO - utilize or build in logic for using an old keyword if needed.
 * @param props
 * @returns b2b verification of benefits modal
 */
const B2BVerificationMsg: React.FC<{
  message: { successMsg?: string; failureMsg?: string }
  isSuccess: boolean
}> = (props?: {
  message: { successMsg?: string; failureMsg?: string }
  isSuccess: boolean
}) => {
  const { message, isSuccess } = props
  const successMessage = message?.successMsg
    ? message?.successMsg
        ?.split(/\\r\\n|\\n|\\r/)
        .map((line, i) => <li key={i}>{line}</li>)
    : null
  const failureMessage = message?.failureMsg
    ? message?.failureMsg
        ?.split(/\\r\\n|\\n|\\r/)
        .map((line, i) => <li key={i}>{line}</li>)
    : null
  const isDefaultMessage = (successMessage || failureMessage) == null

  const getB2bVerificationMessageElement = () => {
    if (isSuccess && isDefaultMessage) {
      return <i>Note: Be sure to confirm this plan & benefits with client.</i>
    } else if (!isDefaultMessage) {
      return successMessage
    }

    return `Sorry, the selected partnership code is not present in the partner configuration available in Retool. Please verify that you have selected a valid partnership code for this booking.`
  }

  return (
    <div className={styles.b2bVerifyMessageModalBodyDefaultText}>
      {getB2bVerificationMessageElement()}
    </div>
  )
}

export default B2BVerificationMsg
